import { render, staticRenderFns } from "./alarmRule.vue?vue&type=template&id=39914128&scoped=true&"
import script from "./alarmRule.vue?vue&type=script&lang=js&"
export * from "./alarmRule.vue?vue&type=script&lang=js&"
import style0 from "./alarmRule.vue?vue&type=style&index=0&id=39914128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39914128",
  null
  
)

export default component.exports